import { filterProps } from '@roc/ui/utils';
import { GridColumnProps } from '@roc/ui';

export const DEFAULT_SORT_MODEL = [{ colId: 'daysInQueue', sort: 'desc' }];

export const constructionManagementColumns: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan Id',
    cellRenderer: 'loanIdCellRenderer',
    width: 110,
    ...filterProps(),
  },
  {
    field: 'status',
    headerName: 'Loan Status',
    minWidth: 130,
    ...filterProps(),
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Subtype',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'daysInQueue',
    headerName: 'Hours in Queue',
    minWidth: 150,
    ...filterProps(),
  },
  {
    field: 'appraisalPresent',
    headerName: 'Appraisal Present',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'realval',
    headerName: 'RealVal',
    minWidth: 110,
    ...filterProps(),
  },
  {
    field: 'reviewSpecialist',
    headerName: 'Review Specialist',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 280,
    ...filterProps(),
  },
  {
    field: 'lenderName',
    headerName: 'Lender Name',
    minWidth: 160,
    ...filterProps(),
  },
  {
    field: 'describeRenovation',
    headerName: 'Special Project Type',
    minWidth: 180,
    ...filterProps(),
  },
  {
    field: 'version',
    headerName: 'Version',
    minWidth: 110,
    ...filterProps(),
  },
];
